import { Link } from 'react-router-dom';

const MARKETPLACE_URL = import.meta.env.VITE_MARKETPLACE_URL || 'https://aws.amazon.com/marketplace/search/results?searchTerms=PartnerBuddy';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-pb-gray-100 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="/partnerbuddy-logo.png"
              alt="PartnerBuddy"
              className="h-8 mb-4"
            />
            <p className="text-pb-gray-500 text-sm">
              AI-powered assistant for AWS Partner Central opportunities.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-pb-gray-800 mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/features" className="text-pb-gray-600 hover:text-pb-orange">
                  Features
                </Link>
              </li>
              <li>
                <a
                  href={MARKETPLACE_URL}
                  className="text-pb-gray-600 hover:text-pb-orange"
                >
                  AWS Marketplace
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-pb-gray-800 mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/support" className="text-pb-gray-600 hover:text-pb-orange">
                  Help Center
                </Link>
              </li>
              <li>
                <a
                  href="mailto:support@rhythmic.dev"
                  className="text-pb-gray-600 hover:text-pb-orange"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-pb-gray-800 mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-pb-gray-600 hover:text-pb-orange">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-pb-gray-600 hover:text-pb-orange">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-pb-gray-100 pt-8 text-center text-sm text-pb-gray-500">
          <p>&copy; {new Date().getFullYear()} Rhythmic Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
